import api from "@/services/axiosInstance"

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "user";
const version = "v1";

// Login user
export const loginV1User = async (credentials) => {
  try {
    const URL = `${API_BASE_URL}/${content}/${version}/login`
    const response = await api.post(URL, credentials)
    return response.data
  } catch (error) {
    throw error.response.data
  }
}